import { render, staticRenderFns } from "./depositMoney.vue?vue&type=template&id=28d9b4e4"
import script from "./depositMoney.vue?vue&type=script&lang=js"
export * from "./depositMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports